export default __webpack_public_path__ + "static/media/service8.803bf74b.jpg";